<div class="page pb-0">
  <div class="container-fluid p-0">
    <div class="breadcrumb-generic breadcrumb-generic--overlay" style="background-image: url('./assets/images/bg_utility.jpg');">
      <div class="container-sm">
        <h5 class="breadcrumb-generic__title">Liste Eventi</h5>
      </div>
    </div>
  </div>
  <div class="container">
    <div class="row">
      <div class="col">
        <iframe class="iframe" title="liste" *ngIf="iFrameUrl" style="width: 100%; min-height: 800px; border: 0" [src]="iFrameUrl"></iframe>
      </div>
    </div>
  </div>
</div>
